import { formatDisplayValue } from "./simulatorUtils";

const CalculatedValue = ({ field, value, onApply }) => {
  return (
    <div className=" d-flex align-items-center" style={{ gap: 5 }}>
      Valeur calculée : {formatDisplayValue(field, value)}
      <button
        type="button"
        className="btn btn-sm btn-default"
        onClick={onApply}
      >
        Appliquer
      </button>
    </div>
  );
};

export default CalculatedValue;
